var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "element product-tile" }, [
    _c("div", { staticClass: "hidden", attrs: { "aria-hidden": "true" } }, [
      _c("div", {
        staticClass: "product-data",
        attrs: {
          "data-handle": _vm.product.handle,
          "data-product": JSON.stringify(_vm.product),
          "data-default-variant": JSON.stringify(
            _vm.product.selected_or_first_available_variant
          )
        }
      })
    ]),
    _vm._v(" "),
    !_vm.product.available
      ? _c("div", { staticClass: "element-callout" }, [
          _c("span", { staticClass: "h4 reset-letterspace lowercase" }, [
            _vm._v("Sold Out")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "element-media" },
      [
        _vm.inBundle
          ? _c("div", { staticClass: "in-bundle" }, [
              _c("p", [_vm._v("Added to Bundle")])
            ])
          : [
              _vm.product.available
                ? _c(
                    "a",
                    {
                      staticClass:
                        "bundle-btn btn btn-outline btn-bg-white btn-small",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addToBundle(_vm.product)
                        }
                      }
                    },
                    [_vm._v("Add to Bundle")]
                  )
                : _c(
                    "a",
                    {
                      staticClass:
                        "bundle-btn btn btn-outline btn-bg-white btn-small",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [_vm._v("Sold Out")]
                  ),
              _vm._v(" "),
              _vm.product.available
                ? _c(
                    "a",
                    {
                      staticClass:
                        "quick-view-bundle-btn btn btn-outline btn-bg-white btn-small",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [_vm._v("Quickview")]
                  )
                : _vm._e()
            ],
        _vm._v(" "),
        _c("img", {
          staticClass: "product-image",
          attrs: { src: _vm.product.featured_image, alt: _vm.product.title }
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "element-content-wrapper" }, [
      _c("div", { staticClass: "meta-wrapper" }, [
        _c("div", { staticClass: "product-info" }, [
          _c(
            "a",
            {
              staticClass: "h4 reset-letterspace lowercase product-title",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addToBundle(_vm.product)
                }
              }
            },
            [_vm._v(_vm._s(_vm.product.title))]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "product-price" }, [
            _vm._v("$" + _vm._s((_vm.product.price / 100).toFixed(2)))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "product-type-link text-muted reset-letterspace" },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.product.type) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "product-actions" },
          [
            _c("p", { staticClass: "product-price" }, [
              _vm._v("$" + _vm._s((_vm.product.price / 100).toFixed(2)))
            ]),
            _vm._v(" "),
            _vm.product.available && !_vm.inBundle
              ? _c(
                  "a",
                  {
                    staticClass: "shop-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.addToBundle(_vm.product)
                      }
                    }
                  },
                  [_vm._v("Add to Bundle")]
                )
              : [
                  !_vm.product.available
                    ? _c("span", [_vm._v("Sold Out")])
                    : _vm._e()
                ]
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }